import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=8443a74e&scoped=true"
import script from "./ProfilePage.js?vue&type=script&lang=js&external"
export * from "./ProfilePage.js?vue&type=script&lang=js&external"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=8443a74e&prod&lang=scss&scoped=true"
import style1 from "./ProfilePage.vue?vue&type=style&index=1&id=8443a74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8443a74e",
  null
  
)

export default component.exports